import { get } from "lodash";
import { Store } from "@reduxjs/toolkit";

export const getVideoCarouselSelector = (store: Store) =>
  get(store, "RaceProgram.videoCarousel", {});
